import { fx } from '../../../../../libs'

export type CreateWalletPayload = {
  name: string
  access: { role: string; accessType: 'full' | 'limited' }[]
}

export const createWallet = fx<CreateWalletPayload, { walletId: number }>({
  method: 'POST',
  url: '/finance/wallet/setup',
})
